import React from 'react';
import PageTemplate from '../../templates/page-template/PageTemplate';
import HomeContent from '../../organisms/HomeContent/HomeContent';

const Home: React.FC = () => {
    return (
        <PageTemplate children={<HomeContent></HomeContent>}></PageTemplate>
    )
}

export default Home;